"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVIDENCE_TOPIC_REGISTRY = exports.EvidenceTopicDefinitionSchema = exports.EvidenceTopicSchema = exports.EvidenceTopic = void 0;
const z = require("zod");
var EvidenceTopic;
(function (EvidenceTopic) {
    EvidenceTopic["Amr"] = "amr";
    EvidenceTopic["OperatingConditions"] = "operating_conditions";
    EvidenceTopic["DriveModes"] = "drive_modes";
    EvidenceTopic["DriveModesVoltageThresholds"] = "drive_modes_voltage_thresholds";
    EvidenceTopic["Pinout"] = "pinout";
    EvidenceTopic["PinoutTable"] = "pinout_table";
    EvidenceTopic["PinoutDiagram"] = "pinout_diagram";
    EvidenceTopic["PinDescriptions"] = "pin_descriptions";
})(EvidenceTopic || (exports.EvidenceTopic = EvidenceTopic = {}));
exports.EvidenceTopicSchema = z.nativeEnum(EvidenceTopic);
exports.EvidenceTopicDefinitionSchema = z.object({
    key: exports.EvidenceTopicSchema,
    parent: exports.EvidenceTopicSchema.nullable(),
    label: z.string(),
    shows: z.string(),
});
exports.EVIDENCE_TOPIC_REGISTRY = {
    [EvidenceTopic.Amr]: {
        key: EvidenceTopic.Amr,
        parent: null,
        label: 'Absolute maximum ratings',
        shows: 'absolute maximum ratings',
    },
    [EvidenceTopic.OperatingConditions]: {
        key: EvidenceTopic.OperatingConditions,
        parent: null,
        label: 'Operating conditions',
        shows: 'operating conditions',
    },
    [EvidenceTopic.DriveModes]: {
        key: EvidenceTopic.DriveModes,
        parent: null,
        label: 'Drive modes',
        shows: 'drive modes',
    },
    [EvidenceTopic.DriveModesVoltageThresholds]: {
        key: EvidenceTopic.DriveModesVoltageThresholds,
        parent: EvidenceTopic.DriveModes,
        label: 'Drive-mode voltage thresholds',
        shows: 'drive-mode voltage thresholds',
    },
    [EvidenceTopic.Pinout]: { key: EvidenceTopic.Pinout, parent: null, label: 'Pinout', shows: 'a pinout' },
    [EvidenceTopic.PinoutTable]: {
        key: EvidenceTopic.PinoutTable,
        parent: EvidenceTopic.Pinout,
        label: 'Pinout table',
        shows: 'a pinout table',
    },
    [EvidenceTopic.PinoutDiagram]: {
        key: EvidenceTopic.PinoutDiagram,
        parent: EvidenceTopic.Pinout,
        label: 'Pinout diagram',
        shows: 'a pinout diagram',
    },
    [EvidenceTopic.PinDescriptions]: {
        key: EvidenceTopic.PinDescriptions,
        parent: null,
        label: 'Pin descriptions',
        shows: 'pin descriptions',
    },
};
//# sourceMappingURL=evidence-topic.js.map